// Split out of ScoringEmphasisPanel.tsx (react-refresh/only-export-components)
// — preset data, not a component. Behavior unchanged.
//
// Preset definitions (grounded in real backend defaults from scoring_config.py)
// goal_blend (backend) = 1 - globalBodyMatchWeight (frontend).
// eom_blend default = 0.10.

export type ScoringPreset = 'balanced' | 'prioritize_goals' | 'overall_form' | 'movement_quality' | 'custom';

export interface PresetConfig {
  id: ScoringPreset;
  label: string;
  description: string;
  // bodyFormWeight maps to globalBodyMatchWeight in the save payload
  // = (1 - goal_blend). Backend goal_blend=0.6 → bodyFormWeight=0.4.
  bodyFormWeight: number;
  eomWeight: number;
}

/** Preset table — each value is grounded in scoring_config.py defaults. */
export const SCORING_PRESETS: PresetConfig[] = [
  {
    id: 'balanced',
    label: 'Balanced',
    description: 'Equal weight between your coaching goals and overall body form.',
    // goal_blend=0.6 default → bodyFormWeight=0.4
    bodyFormWeight: 0.4,
    eomWeight: 0.10,
  },
  {
    id: 'prioritize_goals',
    label: 'Prioritize My Goals',
    description: 'Your specific coaching checkpoints matter more than general body shape.',
    // goal_blend=0.8 → bodyFormWeight=0.2
    bodyFormWeight: 0.2,
    eomWeight: 0.10,
  },
  {
    id: 'overall_form',
    label: 'Overall Form First',
    description: 'Overall body shape similarity matters more than specific goal hits.',
    // goal_blend=0.3 → bodyFormWeight=0.7
    bodyFormWeight: 0.7,
    eomWeight: 0.10,
  },
  {
    id: 'movement_quality',
    label: 'Prioritize Movement Quality',
    description: 'Emphasizes efficient, precise movement with minimal wasted motion.',
    // goal_blend=0.5 (balanced goals/form) + eom=0.25 (significant EOM emphasis)
    bodyFormWeight: 0.5,
    eomWeight: 0.25,
  },
];
